petcoCommonJS={


		langId: "-1",

		storeId: "",

		catalogId: "",
		setCommonParameters:function(langId,storeId,catalogId)
		{
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
		},
		rateLimiterList: {},

			userLocation : { latitude: "", longitude: "" },
		locationConfig: {expirationMin: "",isGoogleGeoAPI: "",HTML5GeoTimeout: "",XHRTimeout: "",googleAPIUrl: "",googleAPIKey: ""},
		IS_HTML5_CALL_COMPLETED :false,
		hidePLPPriceBopusResStates:function(isBopusAreaRestrictedItem,catEntId){
			var oNeareststores = JSON.parse(localStorage.getItem('petcostores'));
			var state = null;
			if(oNeareststores != null && typeof(oNeareststores.petcostores) != 'undefined' && oNeareststores.petcostores.length > 0){
				var aPetcostores = JSON.parse(oNeareststores.petcostores);
				if(aPetcostores != null && aPetcostores.length == 1){
					state = aPetcostores.STATE;
				}else if(aPetcostores != null && aPetcostores.length > 0){
					state = aPetcostores[0].STATE;
				}
			}
			if(state != null)
				if($("#isBOPUSAreaRestictionEnabeled").length > 0 && 'true' == $("#isBOPUSAreaRestictionEnabeled").val() 
					&& 'true' == isBopusAreaRestrictedItem){
					var states = "";
					if($("#BOPUSAreaRestictionState").length > 0){
						states = $("#BOPUSAreaRestictionState").val();
						var stateArray = states.split(",");
						for(var i = 0 ; i < stateArray.length ; i++){
							if(stateArray[i] == state){
								var idVal = "product-price_"+catEntId;
								$("#"+idVal).addClass("hide");
								$("#"+idVal).removeClass("show");
							}		
						}
					}
				}
		},

 				rateLimiter:function(ms, name, callback) {
			if (name in this.rateLimiterList) {
				clearTimeout(this.rateLimiterList[name]);
			}
			this.rateLimiterList[name] = setTimeout(callback, ms);
		},
		repeatDeliveryCartSelected  : function() {
			if(typeof(cmCreateElementTag) == 'function'){
				cmCreateElementTag('ScheduleRD', 'ShoppingCart');
			}
		console.log("RD checkbox CHECK-"+$("#repeat-delivery-checkbox-"+selectedOrderItemId).is(":checked"));
			if ($("#repeat-delivery-checkbox-"+selectedOrderItemId).is(":checked"))
				$("#rddropdown-"+selectedOrderItemId).removeClass("hide");
			else 
				$("#rddropdown-"+selectedOrderItemId).addClass("hide");
			CheckoutHelperJS.removeBannerDismiss();
		},
		repeatDeliveryOptionSelected  : function() {
			console.log("RD radio CHECK-"+$('[name="repeatDelivery"]').is(':checked'));
				if ($('[name="repeatDelivery"]').is(':checked'))
					$("#rddropdown-"+selectedOrderItemId).removeClass("hide");
				else 
					$("#rddropdown-"+selectedOrderItemId).addClass("hide");
		},		
		repeatDeliveryShopCart: function(productId, updateFlag) {
		    if (updateFlag) {
				dojo.forEach(dojo.query('a[data-target="#rdHelp"]'),function(obj){dojo.setAttr(obj,"data-target","#rdHelp_noshow");})
		        if ((document.getElementById("repeat-delivery-radio_" + selectedOrderItemId) && document.getElementById("repeat-delivery-radio_" + selectedOrderItemId).checked)) {
		        	var rd_schedule = '';
		        	if(document.getElementById("repeat-delivery-freq-options-"+ selectedOrderItemId) != undefined && document.getElementById("repeat-delivery-freq-options-"+ selectedOrderItemId) != null){
		        		rd_schedule = document.getElementById('repeat-delivery-freq-options-'+selectedOrderItemId).value;
		        	}
		            var rdFrequency = '';
		            var rdInitialFirstOrder = '';
		            if(document.getElementById("repeat-delivery-first-ship-options-"+ selectedOrderItemId) != undefined && document.getElementById("repeat-delivery-first-ship-options-"+ selectedOrderItemId) != null){
						var rdInitialFirstOrderValue = document.getElementById('repeat-delivery-first-ship-options-'+ selectedOrderItemId).value;
						if(rdInitialFirstOrderValue != null && rdInitialFirstOrderValue != undefined) {
							if (rdInitialFirstOrderValue == "now") {
								rdFrequency = document.getElementById('repeat-delivery-freq-options_future_order-'+ selectedOrderItemId).value;
							} else {
								rdFrequency = document.getElementById('repeat-delivery-freq-options_future_order-'+ selectedOrderItemId).value;
								rdInitialFirstOrder = rdInitialFirstOrderValue;
							}
						}
					}

		            		            if (rdFrequency == '' && rd_schedule != '')
		            	rdFrequency = rd_schedule;

		            		            if (rd_schedule == '' && rdFrequency !='')
		            	rd_schedule = rdFrequency;
		            var rd_sku = document.getElementById('rd_sku_' + selectedOrderItemId).value;
		            this.updateORResetPrice(selectedOrderItemId, rdFrequency, rdInitialFirstOrder, 'AjaxUpdateOrderItemShopCart');
		        } else if((document.getElementById("one-time-delivery_" + selectedOrderItemId) && document.getElementById("one-time-delivery_" + selectedOrderItemId).checked)){
		            this.updateORResetPrice(selectedOrderItemId, '', '', 'AjaxUpdateOrderItemShopCart');
		        }else if((document.getElementById("store-pickup_" + selectedOrderItemId) && document.getElementById("store-pickup_" + selectedOrderItemId).checked)){
		            this.updateORResetPrice(selectedOrderItemId, '', '', 'AjaxUpdateOrderItemShopCart');
		        }else if((document.getElementById("sameday-delivery_" + selectedOrderItemId) && document.getElementById("sameday-delivery_" + selectedOrderItemId).checked)){
		            this.updateORResetPrice(selectedOrderItemId, '', '', 'AjaxUpdateOrderItemShopCart');
		        }
		    }
		},
		 selectRD : function()
		 {
			document.getElementById("repeat-delivery-radio").checked = true;
		 },
		 selectRDcheckbox : function() {
			document.getElementById("repeat-delivery-checkbox-"+selectedOrderItemId).checked = true;
		 },
		 selectRepeatDeliveryRadio:function(){
			document.getElementById("rd-radio-yes").checked = true;
		 },
		 updateORResetPriceWait:function(orderItemId, rdFrequency, action)
		 {
			 setTimeout(dojo.hitch(this,"updateORResetPrice",orderItemId, rdFrequency, action),1500);
		 },

		 		 updateORResetPrice:function(orderItemId, rdFrequency, rdInitialFirstOrder, action)
		 {
			 var params = [];
			 params["storeId"] = this.storeId;
			 params["catalogId"] = this.catalogId;
			 params["langId"] = this.langId;
			 if(rdFrequency != '')
				 params["rdFrequency"] = rdFrequency;
			 if(rdInitialFirstOrder != '')
				 params["rdInitialFirstOrder"] = rdInitialFirstOrder;
			 params["priceChange"] = true;
			 params["orderItemId"] = orderItemId;
			 params["callToODM"] = "true";
			 if($("#ignoreNewRowCreation_"+orderItemId).size() != 0){
				 params["isPersonalizationRow"] = $("#ignoreNewRowCreation_"+orderItemId).val();
			 }
			 if($('input[type="radio"][name="bopusCartSelect_'+orderItemId+'"]:checked').size() > 0 && 
					 $('input[type="radio"][name="bopusCartSelect_'+orderItemId+'"]:checked')[0].value == 'store-pickup'){
				 var BOPUSSHIPMODE = $("#BOPUS_SHIPMODE");
				 var BOPUSFFMCENTER = $("#BOPUS_FFMCENTER");
					if(BOPUSSHIPMODE.size() > 0 && BOPUSFFMCENTER.size() > 0 ){
						params["shipModeId"]		= BOPUSSHIPMODE.val();
						params["fulfillmentCenterId"] = BOPUSFFMCENTER.val();
						params["fromBopusPage"] = true;
					}
			 }else if($('input[type="radio"][name="bopusCartSelect_'+orderItemId+'"]:checked').size() > 0 && 
					 $('input[type="radio"][name="bopusCartSelect_'+orderItemId+'"]:checked')[0].value == 'sameday_delivery'){
				 var sddffmcenter = $("#SDD_fulfillmentcer_"+selectedOrderItemId).val();
					console.log("sddffmcenter -> "+sddffmcenter);
					var SAMEDAYSHIPMODE = $("#SAMEDAY_SHIPMODE_ID");
					if(SAMEDAYSHIPMODE.size() > 0 ){
						params["shipModeId"]		= SAMEDAYSHIPMODE.val();
						params["fulfillmentCenterId"] = sddffmcenter;
						params["fromBopusPage"] = false;
						params["SameDayOpted"] = true;
					} 
			 }else{
				 var DEFAULTFFMCENTER = $("#DEFAULT_FFMCENTER");
				var DEFAULTSHIPMODE = $("#DEFAULT_SHIPMODE");
				if(DEFAULTFFMCENTER.size() > 0 && DEFAULTSHIPMODE.size() > 0 ){
					params["shipModeId"]		= DEFAULTSHIPMODE.val();
					params["fulfillmentCenterId"] = DEFAULTFFMCENTER.val();
					params["fromBopusPage"] = false;
				}else{
					params["shipModeId"]		= "10650";
					params["fulfillmentCenterId"] = "10051";
					params["fromBopusPage"] = false;
				}

				 			 }

			 			 var isEASession = dojo.cookie('isEASession');
			 if (isEASession == "yes" ){
					params.calculationUsage = "-1,-2,-3,-4,-5,-7";
				}
				else{
					params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
				}

			 			cursor_wait();
			 if(action != ''){
				 wc.service.invoke("AjaxUpdateOrderItemShopCartRDPromo",params);
			 }else{
				 wc.service.invoke("AjaxUpdateOrderItem",params); 
			 }


				 				 		 },
		 updateORResetPriceCheckout:function(orderItemIds, rdFrequency, rdInitialFirstOrder, action)
		 {
			 var params = [];
			 params["storeId"] = this.storeId;
			 params["catalogId"] = this.catalogId;
			 params["langId"] = this.langId;
			 if(rdFrequency != '')
				 params["rdFrequency"] = rdFrequency;
			 if(rdInitialFirstOrder != '')
				 params["rdInitialFirstOrder"] = rdInitialFirstOrder;
			 params["priceChange"] = true;
			 var orderItemIdsStr = orderItemIds + '';
			 var orderItemIdArr = orderItemIdsStr.split(',');
			 if(orderItemIdArr.length > 1){
				 for(var i=1;i<= orderItemIdArr.length; i++){
					 params["orderItemId_"+i] = orderItemIdArr[i-1];
				 }

				 			 }else{
				 params["orderItemId"] = orderItemIds;
			 }


			 			 			 params["callToODM"] = "true";
			 params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";

			 			 cursor_wait();
			 if(action != ""){
				  wc.service.invoke("AjaxUpdateOrderItemShopCartRDPromo",params);
			 }else{
				 wc.service.invoke("AjaxUpdateOrderItem",params); 
			 }


				 						 },

			 clearAllErrorDivsForAddShippingAddress:function()
		 {
			 $('label[for="shipping-address-nickname"]').removeClass("invalid valid");
			 $('input#shipping-address-nickname').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-nickname').val("");
			 $('div#shipping-address-nickname-err').html("")

			 			 $('label[for="shipping-address-firstname"]').removeClass("invalid valid");
			 $('input#shipping-address-firstname').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-firstname').val("");
			 $('div#shipping-address-firstname-err').html("")

			 			 $('label[for="shipping-address-lastname"]').removeClass("invalid valid");
			 $('input#shipping-address-lastname').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-lastname').val("");
			 $('div#shipping-address-lastname-err').html("")

			 			 $('label[for="shipping-address-phone"]').removeClass("invalid valid");
			 $('input#shipping-address-phone').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-phone').val("");
			 $('div#shipping-address-phone-err').html("")

			 			  $('label[for="shipping-address-address1"]').removeClass("invalid valid");
			 $('input#shipping-address-address1').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-address1').val("");
			 $('div#shipping-address-address1-err').html("")

			 			  $('label[for="shipping-address-address2"]').removeClass("invalid valid");
			 $('input#shipping-address-address2').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-address2').val("");
			 $('div#address2Error').html("")

			 			 	  $('label[for="shipping-address-city"]').removeClass("invalid valid");
			 $('input#shipping-address-city').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-city').val("");
			 $('div#shipping-address-city-err').html("")

			 			   $('label[for="shipping-address-state"]').removeClass("invalid valid");
			 $('input#shipping-address-state').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-state').val("");
			 $('div#shipping-address-state-err').html("")

			 			   $('label[for="shipping-address-zipCode"]').removeClass("invalid valid");
			 $('input#shipping-address-zipCode').removeClass("invalid valid").addClass("form-control");
			 $('input#shipping-address-zipCode').val("");
			 $('div#shipping-address-zipCode-err').html("")



			 							$('div#shipping_address_page_error div div div#alert-danger').html("");
				$('div#shipping_address_page_error').removeClass("show");
				$('div#shipping_address_page_error').addClass("no-show");
		 },
		clearPromotionLessThanZero:function(){
				var percentageLimit = 1;
				dojo.forEach(dojo.query('span#rdPriceDiv span.product-price-banner'),function(obj){
					var percentage = obj.innerText.toUpperCase().replace('SAVE','').replace('UP','').replace('TO','').replace('%','').trim();
					if(!isNaN(percentage) && ((percentage*1) < percentageLimit)){
						obj.style.display = 'none';
					}
				})
				dojo.forEach(dojo.query('div.product-price span.product-price-save'),function(obj){
					var percentage = obj.innerText.toUpperCase().replace('SAVE','').replace('UP','').replace('TO','').replace('%','').trim();
					if(!isNaN(percentage) && ((percentage*1) < percentageLimit)){
						obj.style.display = 'none';
					}
				})
			}, 

							showModal: function(formId, formpadClass){
					dojo.forEach(dojo.query('div[id="modal-Personalization"] input[type=text]'),function(obj){
						obj.value="";console.log("hi"+obj.value);
					});

										require(["dojo/dom-style", "dojo/query"], function(domStyle, query){	

						var win = petcoCommonJS.getWindowSize(),
							modal = document.getElementById('modal-'+formId);
						modal = modal ? modal : document.getElementById(formId);
						document.body.style.overflow = "hidden";
						petcoCommonJS.showBgScreen();


						query(".modal-form").style.display = "none";
						document.getElementById(formId).style.display = "block";
						if (typeof(formpadClass) == "string") {
					    	query('.petco-modal .form-modal-form').removeClass('form-modal-padding-deep').removeClass('form-modal-padding-shallow');
					        query('.petco-modal .form-modal-form').addClass('form-modal-padding-'+formpadClass);
					      }
						modal.style.display = "block";
						modal.classList.add("in");
						modal.setAttribute('tabindex', '-1');
						modal.setAttribute('aria-hidden', 'false');
						modal.setAttribute('role', 'dialog');
						modal.focus();
						domStyle.set(modal, {
							left: "50%",
							top: "50%",
							transform: "translateX(-50%) translateY(-50%)"
				   	    });

						if (typeof window.ontouchstart !== 'undefined' && document.documentElement.classList.contains('dj_safari')){

							document.body.style.overflow = "initial";
							document.documentElement.classList.add('fixed');

														if (window.pageYOffset){
								var scrollTop = window.pageYOffset;
								document.body.style.top = (-scrollTop)+"px";
							}
						}

											document.addEventListener("focus", function(e) {
							if (!modal.contains(e.target)) {
								e.stopPropagation();
								modal.focus();
							}
						}, true);

											});
					dojo.query("#pdp-submit-button .btn-primary").addClass("disabled");
				}, 
				submitFindDeactiveUserSearchForm: function( ){
					if(!submitRequest()){
						 return;
					} 
				 document.getElementById("FindDeactiveUserSearchForm").submit();
				},

			hideModal: function(modalId){
				var modal = document.getElementById(modalId);
				modal.style.display = 'none';
				modal.classList.remove("in");
				document.body.style.overflow = "";
				document.body.style.position = "";
				petcoCommonJS.hideBgScreen();
				cursor_clear();
				if (typeof window.ontouchstart !== 'undefined' && document.documentElement.classList.contains('dj_safari')){
					document.documentElement.classList.remove('fixed');
					var offset = parseInt(document.body.style.top, 10);
					document.body.scrollTop = -(offset);
				}
				modal.removeAttribute('tabindex');
				modal.removeAttribute('role');
				modal.setAttribute('aria-hidden', 'true');
				if (modalId == 'modal-notification-alert'){
					$('#modal-notification-alert-message').html('');
				}
			},
			showBgScreen: function(){
				var bgScreen = document.getElementById('form-modal-screen');
				bgScreen.style.display = 'block';
			},
			hideBgScreen: function(){
				var bgScreen = document.getElementById('form-modal-screen');
				bgScreen.style.display = 'none';
			},
			getWindowSize: function() {
			    var  w = window,
			     d = document,
			     e = d.documentElement,
			     g = d.getElementsByTagName('body')[0],
			    wW = w.innerWidth || e.clientWidth  || g.clientWidth;
			    wH = w.innerHeight || e.clientHeight || g.clientHeight;

				    return [ wW, wH ];
			  },
			  bopusCartEnableRadio:function(){
				  try {
					  var iscart =$('article.cart-product-item');
					  if(iscart.length > 0){
						  try{
						  	$('a[id^="store-pickup_"]').on('click',function(e){
						  		var nextCartChangeEventstorepickup = {};
						  		var thisElementNextPickUp = e.target.id;
						  		var OrdersItemsIdNextPickUp = thisElementNextPickUp.replace("store-pickup_","");
						  		if(dojo.byId("removedSKUID_"+OrdersItemsIdNextPickUp) != undefined && dojo.byId("removedSKUID_"+OrdersItemsIdNextPickUp) != null){
						  			nextCartChangeEventstorepickup["product_id"] = dojo.byId("removedSKUID_"+OrdersItemsIdNextPickUp).value;
						  		}
						  		if(dojo.byId("removedPrdName_"+OrdersItemsIdNextPickUp) != undefined && dojo.byId("removedPrdName_"+OrdersItemsIdNextPickUp) != null){
						  			nextCartChangeEventstorepickup["product_name"] = dojo.byId("removedPrdName_"+OrdersItemsIdNextPickUp).value;
						  		}
						  		if($("#product_"+OrdersItemsIdNextPickUp).size() > 0){
						  			nextCartChangeEventstorepickup["product_parent_sku"] = $("#product_"+OrdersItemsIdNextPickUp).val();
						  		}
						  		if(dojo.byId("rd_sku_"+OrdersItemsIdNextPickUp) != undefined && dojo.byId("rd_sku_"+OrdersItemsIdNextPickUp) != null){
						  			nextCartChangeEventstorepickup["product_sku"] = dojo.byId("rd_sku_"+OrdersItemsIdNextPickUp).value;
						  		}			
						  		nextCartChangeEventstorepickup["event_name"] = "cart_to_one_time_delivery";
						  		pushEvent(nextCartChangeEventstorepickup);
						  	})
						  $('a[id^="one-time_"]').on('click',function(e,obj){

						  		var nextCartChangeEventstoreDelivery = {};
						  		var thisElementNextDelivery = e.target.id;
						  		var OrdersItemsIdNextDelivery = thisElementNextDelivery.replace("one-time_","");
						  		if(dojo.byId("removedSKUID_"+OrdersItemsIdNextDelivery) != undefined && dojo.byId("removedSKUID_"+OrdersItemsIdNextDelivery) != null){
						  			nextCartChangeEventstoreDelivery["product_id"] = dojo.byId("removedSKUID_"+OrdersItemsIdNextDelivery).value;
						  		}
						  		if(dojo.byId("removedPrdName_"+OrdersItemsIdNextDelivery) != undefined && dojo.byId("removedPrdName_"+OrdersItemsIdNextDelivery) != null){
						  			nextCartChangeEventstoreDelivery["product_name"] = dojo.byId("removedPrdName_"+OrdersItemsIdNextDelivery).value;
						  		}
						  		if($("#product_"+OrdersItemsIdNextDelivery).size() > 0){
						  			nextCartChangeEventstoreDelivery["product_parent_sku"] = $("#product_"+OrdersItemsIdNextDelivery).val();
						  		}
						  		if(dojo.byId("rd_sku_"+OrdersItemsIdNextDelivery) != undefined && dojo.byId("rd_sku_"+OrdersItemsIdNextDelivery) != null){
						  			nextCartChangeEventstoreDelivery["product_sku"] = dojo.byId("rd_sku_"+OrdersItemsIdNextDelivery).value;
						  		}			
						  		nextCartChangeEventstoreDelivery["event_name"] = "cart_to_bopus";
						  		pushEvent(nextCartChangeEventstoreDelivery);

						  								  		})
						  }catch(err){
						  	return true;
						  }
					  }else{
						  if($(".noRdPdpDesign").length > 0){
							  return;
						  }
						  $(".repeat-delivery-select_cart").each(function(ind,obj){
								var orderitemsId = obj.id.replace("repeat-delivery-select_","");
								 var $radioButtons = $("input[type='radio'][name='bopusCartSelect_"+orderitemsId+"']");
								 	  $radioButtons.parents('.radio').removeClass('selected');
								  $radioButtons.filter(':not(:checked)').removeAttr('checked');
								  $radioButtons.filter(':checked').attr('checked', 'checked');
								  $radioButtons.filter(':checked').parents('.radio').addClass('selected');
								  if($('#cart-store-pickup-dropdown_'+orderitemsId).length > 0){
									  if($('#store-pickup_'+orderitemsId+':checked.store-pickup-option-input').length > 0){
									$('#cart-store-pickup-dropdown_'+orderitemsId).removeClass('half').addClass('open');
								 }else{
									$('#cart-store-pickup-dropdown_'+orderitemsId).addClass('half').removeClass('open');
								 }
								  }
							    $radioButtons.on('change', function(e) {
							    	try{
										var cartChangeEvent = {};
										var thisElement = e.target.id;
										if(dojo.byId("removedSKUID_"+orderitemsId) != undefined && dojo.byId("removedSKUID_"+orderitemsId) != null){
											cartChangeEvent["product_id"] = dojo.byId("removedSKUID_"+orderitemsId).value;
										}
										if(dojo.byId("removedPrdName_"+orderitemsId) != undefined && dojo.byId("removedPrdName_"+orderitemsId) != null){
											cartChangeEvent["product_name"] = dojo.byId("removedPrdName_"+orderitemsId).value;
										}
										if($("#product_"+orderitemsId).size() > 0){
											cartChangeEvent["product_parent_sku"] = $("#product_"+orderitemsId).val();
										}
										if(dojo.byId("rd_sku_"+orderitemsId) != undefined && dojo.byId("rd_sku_"+orderitemsId) != null){
											cartChangeEvent["product_sku"] = dojo.byId("rd_sku_"+orderitemsId).value;
										}

																					if(thisElement.indexOf('one-time-delivery') != -1){
											cartChangeEvent["event_name"] = "cart_to_one_time_delivery";
										}
										if(thisElement.indexOf('repeat-delivery-radio') != -1){
											cartChangeEvent["event_name"] = "cart_to_repeat_delivery";
											cartChangeEvent["product_delivery_type"] = "repeat";
											var cartOrderId = '';
											if(dojo.cookie("WC_CartOrderId_10151")!= undefined && dojo.cookie("WC_CartOrderId_10151")!= null){
												cartOrderId = dojo.cookie("WC_CartOrderId_10151");
											}
											cartChangeEvent["cart_id"] = cartOrderId;									
											var rd_schedule = '';
											var freq = '';
								        	if(document.getElementById("repeat-delivery-freq-options-"+ selectedOrderItemId) != undefined && document.getElementById("repeat-delivery-freq-options-"+ selectedOrderItemId) != null){
								        		rd_schedule = document.getElementById('repeat-delivery-freq-options-'+selectedOrderItemId).value;
								        		if(rd_schedule!=''){
								        			var res = rd_schedule.split("_");
								        			if(res[1] == 'W'){
								        				freq = res[0]+ ' Weeks';
								        			} else if(res[1] == 'M'){
								        				freq = res[0]+ ' Months';
								        			}

								        											        		}
								        	}
											cartChangeEvent["product_rd_schedule_time"] = freq;
										}
										if(thisElement.indexOf('store-pickup') != -1){
											cartChangeEvent["event_name"] = "cart_to_bopus";
										}

																	 				pushEvent(cartChangeEvent);

																	    	}catch(err){
							    		return true;
							    	}



					 											 																			      $radioButtons.parents('.radio').removeClass('selected');
							      $radioButtons.filter(':not(:checked)').removeAttr('checked');
							      $radioButtons.filter(':checked').attr('checked', 'checked');
							      $radioButtons.filter(':checked').parents('.radio').addClass('selected');
							      if($('#cart-store-pickup-dropdown_'+orderitemsId).length > 0){
							        if (e.currentTarget.classList.contains('store-pickup-option-input')) {
							     		 $('#cart-store-pickup-dropdown_'+orderitemsId).removeClass('half').addClass('open');
								    } else {
								     	 $('#cart-store-pickup-dropdown_'+orderitemsId).addClass('half').removeClass('open');
								    }
							    }
							    });
							})						 
						$('.repeat-delivery-select_cart .store-pickup p.lsa-hours a[data-toggle="popover"]').popover({html:true,trigger: "hover focus" });


						 					  }



				  				 				 					  petcoCommonJS.chkBopusInventoryAvailabilityInCart();
				  }
				  catch(err) {
				    console.log("Error>>>"+err);
				  }

				  			  },
			  chkBopusInventoryAvailabilityInCart:function(){
				  var storeID = $('#bopusPhysicalStoreSelected').val();	
				  if(typeof(storeID) != "undefined"){
					  var bopusCatentryList = {};
					  $(".bopusLineitemsToChkInv").each(function(ind,obj){
						  var lineValArr = obj.value.split("|");
						  var lineValues = [];
							 if (typeof(bopusCatentryList[lineValArr[0]]) != "undefined"){
								 lineValues= bopusCatentryList[lineValArr[0]];
							 }

														 lineValues.push(obj.value);
							 bopusCatentryList[lineValArr[0]] = lineValues;						  
					  });
					  var _sStoreId = '10151';
					  var url = '',
				 		protocol = window.location.protocol,
				 		hostname = window.location.hostname,
						portname = window.location.port,
				 		rootPath = '/wcs/resources/store/'+_sStoreId+'/yih/inventoryavailability/';
						if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
							rootPath = '/wcs/previewresources/store/'+_sStoreId+'/petcostorelocator/';
						}

												if( portname != "" ){
							hostname = hostname+":"+portname;
						}

											  var catentryLists = "";
					  for( var i in bopusCatentryList){
						  if( catentryLists == ""){
							  catentryLists = i;
						  }else{
							  catentryLists = catentryLists + "," +i;
						  }

						  					  }
					  if(catentryLists != ""){
						  petcoCommonJS.isDisableCheckOutButtonForBopus = false;
						  petcoCommonJS.isEnableCheckOutButtonForBopus = false;
						  var inventorySystem = $('#inventorySystem').val();
						  if(inventorySystem == -4) {	
							  var params = new Object();
							  params.itemId = catentryLists;							 		
							  params.storeLoc = storeID;
							  params.fetchStoreInventory = true;							  
							  dojo.xhrPost({
									url: getAbsoluteURL() + "GetInventoryStatusByIDView",
									handleAs: "json-comment-filtered",
									content: params,
									service: this,
									load: function(data){
										petcoCommonJS.bopusShowAvailability(data,bopusCatentryList);
									},
									error: function(errObj,ioArgs) {
										petcoCommonJS.disableCheckoutButton();
							 			petcoCommonJS.showDefaultInventoryTxt();
									}
							  });
						  } else {	
							  var url = protocol+"//"+hostname+rootPath+catentryLists+"/?physicalStoreId="+storeID;
							 	$.ajax({
							 		url : url,
							 		type : 'GET',
							 		cache : false,
							 		contentType: 'application/json',
							 		dataType: 'json',
							 		data: '',
							 		success: function(data){
							 			petcoCommonJS.bopusPhysicalStoreInventoryLoad(data,bopusCatentryList)
							 		},
							 		error: function(){
							 			petcoCommonJS.disableCheckoutButton();
							 			petcoCommonJS.showDefaultInventoryTxt();
							 		}
							 	}); 
						  }
					  }
				  }else{
					  elCARTContainer = $('article.cart-product-item');
						 if(elCARTContainer.length > 0){
							 petcoCommonJS.isDisableCheckOutButtonForBopus = false;
						 }
						 var checkoutButtonDisabled = false;
						 $("input[name=bopusLineitems]").each(function() { 
							var name= this.value;
							if(name != undefined){
								  var idVal = name.split("|");
								  var idConstructed = "_"+idVal[0]+"_"+idVal[1];
								  var nonAvailabilityEle = "cart_bopusdeailsNotAvailableSelectable"+idConstructed;
								  $('[id="'+nonAvailabilityEle+'"]').addClass("show");
								  $('[id="'+nonAvailabilityEle+'"]').removeClass("hide");	
								  checkoutButtonDisabled = true;
							}							
		             	});   
						 if(checkoutButtonDisabled){
							 petcoCommonJS.isDisableCheckOutButtonForBopus = true;
							 $("div.petco-checkout a#continueReviewPage").removeClass("cart-yellow-btn");
							 $("div.petco-checkout a#continueReviewPage").addClass("disabled logged-out");
							 $('[id=bopusStoreDisabledErr]').removeClass("hide");
							 $("a#PayPalCartButton").addClass("disabled")
						 }

						 				  }

				  			  },
			  showDefaultInventoryTxt: function(){
				  $('p[id^="cart_bopusFreePickMsg_"]').removeClass("hide");
				  $('span[id^="cart_bopusdeailsInStockSelectable_"]').removeClass("show");
				  $('span[id^="cart_bopusdeailsInStockSelectable_"]').addClass("hide");
				  $('span[id^="cart_bopusdeailsLowInventorySelectable_"]').removeClass("show");
				  $('span[id^="cart_bopusdeailsLowInventorySelectable_"]').addClass("hide");
				  $('span[id^="cart_bopusdeailsNotAvailableSelectable_"]').removeClass("hide");
				  $('span[id^="cart_bopusdeailsNotAvailableSelectable_"]').addClass("show");
			  },
			  disableCheckoutButton : function(){
				  $("div#payment-buttons a.btn-paypal.disabled").removeClass("disabled");
				  if($('input[id^="store-pickup_"]:checked').length > 0){
					  $("div.vendor-checkout-bottom .btn-paypal").addClass("disabled");
					  $("div.petco-checkout #continueReviewPage").addClass("disabled");
					  $("div#payment-buttons a.btn-paypal:not(.disabled)").addClass("disabled");
					  petcoCommonJS.isDisableCheckOutButtonForBopus = true;
				  }else{
					  $("div#payment-buttons a.btn-paypal.disabled").removeClass("disabled");
					  petcoCommonJS.enableCheckoutButton();
					  if ($('#deliveryMethodError_'+orderItemId).hasClass("hide")) {
						  petcoCommonJS.isDisableCheckOutButtonForBopus = false;
					  }
				  }
			  },
			  enableCheckoutButton : function(){
				  var isInStoreProdutError = false;
				  var isOutOfStockItemExists = false;
				  var isSDDOSSItemPresent = false;
				  $("div#payment-buttons a.btn-paypal.disabled").removeClass("disabled");
				  $.each($('input[id^="inStoreProductFlag_"]'),function(i,obj){
					  var identifier = obj.id.split("_");
					  var orderItemId = identifier[identifier.length-1];
					  if(($("input[name=bopusCartSelect_"+orderItemId+"]:checked").val() != 'store-pickup')
							  && ($("input[name=bopusCartSelect_"+orderItemId+"]:checked").val() != 'sameday_delivery')
							  && ($("input[name=bopus-item_"+orderItemId+"]").val()!='true')
							  && ($("input[name=sdd-item_"+orderItemId+"]").val()!='true')){ 
						  $("div#payment-buttons a.btn-paypal:not(.disabled)").addClass("disabled");
						  petcoCommonJS.isDisableCheckOutButtonForBopus = true;
						  isInStoreProdutError = true;
						  $('#deliveryMethodError_'+orderItemId).removeClass("hide");
						  $('#deliveryMethodError_'+orderItemId+' .promo-error-text').html(MessageHelper.messages["ERR_DELIVERY_METHOD"]);
						  $("div.vendor-checkout-bottom .btn-paypal").addClass("disabled");
						  $("div.petco-checkout #continueReviewPage").addClass("disabled");
						  $("div.petco-checkout a#continueReviewPage").removeClass("cart-yellow-btn full-width"); 
						  $("div.petco-checkout a#continueReviewPage").addClass(" btn-large btn-full logged-out btn-primary");
						  $("div.petco-checkout a#continueReviewPage").attr("href","javascript:void(0);")
						  $('#klarna-button').addClass('hide');
					  }
				  });
				  if($("#sddOutOfStockItemExists").length >0 && $("#sddOutOfStockItemExists").val() == 'true' ){
					  isSDDOSSItemPresent = $("#sddOutOfStockItemExists").val();
					  $("div#payment-buttons a.btn-paypal:not(.disabled)").addClass("disabled");
					  $('#klarna-button').addClass('hide');
					  petcoCommonJS.isDisableCheckOutButtonForBopus = true;
				  }

				  				  if($(!isSDDOSSItemPresent && "#outOfStockItemExists").length >0 ){
					  isOutOfStockItemExists = $("#outOfStockItemExists").val();
					  $("div#payment-buttons a.btn-paypal:not(.disabled)").addClass("disabled");
					  $('#klarna-button').addClass('hide');
					  petcoCommonJS.isDisableCheckOutButtonForBopus = true;
				  }
				  if(!isSDDOSSItemPresent && !isInStoreProdutError && !isOutOfStockItemExists ){
					  $("div.vendor-checkout-bottom .btn-paypal").removeClass("disabled");
					  $("div.petco-checkout #continueReviewPage").removeClass("disabled");
					  $("div#payment-buttons a.btn-paypal.disabled").removeClass("disabled");
					  $('#klarna-button').removeClass('hide');
					  petcoCommonJS.isDisableCheckOutButtonForBopus = false; 
				  }
			  },
			  bopusShowAvailability: function(data, bopusCatentryList) {

				  				  $('p[id^="cart_bopusFreePickMsg_"]').removeClass("hide");
				  $('span[id^="cart_bopusdeailsInStockSelectable_"]').addClass("hide");

				  				  if(typeof(data["inStoreInventory"]) != 'undefined') {
					  var inStoreInventory = data["inStoreInventory"].stores;
					  var showError = false;
					  for (var s in inStoreInventory ){						  
						  var catentryIdFromRespose = inStoreInventory[s].catentryId;	
						  if(typeof(catentryIdFromRespose) != 'undefined'){
							  if(typeof(inStoreInventory[s].alertLevel) != 'undefined'){
								  petcoCommonJS.showAvailabilityTest(bopusCatentryList[catentryIdFromRespose],inStoreInventory[s].alertLevel.toUpperCase(), inStoreInventory[s].availableQuantity);
							  }else{
								  showError = true;
							  }
						  }else{
							  showError = true;
						  }			
					  }
					  if(showError){
						  petcoCommonJS.disableCheckoutButton();
					  }else{						  
						  if(petcoCommonJS.isDisableCheckOutButtonForBopus){
							  petcoCommonJS.disableCheckoutButton();
						  }else{
							  petcoCommonJS.enableCheckoutButton();
						  }						  
					  }	
				  } else {
					  petcoCommonJS.disableCheckoutButton();
				  }
			  },
			  bopusPhysicalStoreInventoryLoad: function(data,bopusCatentryList){
				  var inStoreInventory = data["inStoreInventory"];
				  if(typeof(inStoreInventory) != 'undefined'){
					  var showError = false;
					  for (var s in inStoreInventory ){
						  var catentryIdFromRespose = inStoreInventory[s].catEntryId;
						  if(typeof(catentryIdFromRespose) != 'undefined'){
							  if(typeof(inStoreInventory[s].alertLevel) != 'undefined'){
									  petcoCommonJS.showAvailabilityTest(bopusCatentryList[catentryIdFromRespose],inStoreInventory[s].alertLevel.toUpperCase(), inStoreInventory[s].availableQuantity);
							  }else{
								  showError = true;
							  }

						  }else{
							  showError = true;
						  }

										  }
					  if(showError){
						  petcoCommonJS.disableCheckoutButton();
					  }else{

						  						  if(petcoCommonJS.isDisableCheckOutButtonForBopus){
							  petcoCommonJS.disableCheckoutButton();
						  }else{
							  petcoCommonJS.enableCheckoutButton();
						  }

						  					  }

					  				  }else{
					  petcoCommonJS.disableCheckoutButton();
				  }


			  },
			  isDisableCheckOutButtonForBopus:false,
			  isEnableCheckOutButtonForBopus:false,
			  showAvailabilityTest: function(pushVals,avlTxt, availableQty){
				  var enableButton = false;
				  var disableButton = false;
				  var catentryId
				  var BOPUSAreaRestictionState = $(".BOPUSAreaRestictionState");
				  var hidecssclassBOPUSResrictionMap = {};
				  var hidecssclassBOPUSResriction =$(".hidecssclassBOPUSResriction");
				  var bopusStoreState = $(".bopusStoreState");
				  for(var i = 0 ; i < pushVals.length ; i++){
					  var idVal = pushVals[i].split("|");
					  var idConstructed = "_"+idVal[0]+"_"+idVal[1];
					  catentryId = idVal[0]
					  var bopusSelectIdLength = $('input#store-pickup_'+idVal[1]+':checked').length;
					  var availabilityEle = "cart_bopusdeailsInStockSelectable"+idConstructed;
					  var availabilityLabelEle = "cart_bopusdeailsInStockSelectable_label"+idConstructed;
					  var nonAvailabilityEle = "cart_bopusdeailsNotAvailableSelectable"+idConstructed;
					  var lowAvailabilityEle = "cart_bopusdeailsLowInventorySelectable"+idConstructed;
					  var qtyOrdered = parseInt(idVal[2]);
					  var qtyAvailable = qtyOrdered;
					  if(availableQty != undefined && availableQty != null) {
						  qtyAvailable = parseInt(availableQty);
					  }

									  if(BOPUSAreaRestictionState.length > 0){
						  var BOPUSAreaRestictionStateAray = BOPUSAreaRestictionState[0].value.split(",");
						  if(hidecssclassBOPUSResriction.length > 0){

														 $.each(hidecssclassBOPUSResriction,function(i,obj){
								 hidecssclassBOPUSResrictionMap[obj.value]="yes";
							 })
						  }

						  						  if(typeof(hidecssclassBOPUSResrictionMap[idVal[0]]) != 'undefined' && bopusStoreState.length > 0 ){
								for(var e = 0 ; e < BOPUSAreaRestictionStateAray.length ; e++){
						 			if(BOPUSAreaRestictionStateAray[e] == bopusStoreState[0].value){
						 				avlTxt = 'RED';
						 			}
						 		}
						  }
					  }

					  if((avlTxt == 'GREEN') && (qtyOrdered > qtyAvailable)){
						  avlTxt = 'YELLOW';
					  }

					  					  if(avlTxt == 'GREEN'){
						  $('[id="'+availabilityEle+'"]').addClass("show");
						  $('[id="'+availabilityEle+'"]').removeClass("hide");
						  $('[id="'+availabilityLabelEle+'"]').removeClass("hide");
						  $('[id="'+nonAvailabilityEle+'"]').addClass("hide");
						  $('[id="'+nonAvailabilityEle+'"]').removeClass("show");
						  $('[id="'+lowAvailabilityEle+'"]').addClass("hide");
						  $('[id="'+lowAvailabilityEle+'"]').removeClass("show");
						  if(bopusSelectIdLength > 0){
							  enableButton = true;
						  }
						  if($('#tel_inv_status_BOPUS_'+catentryId).length){
							  $('#tel_inv_status_BOPUS_'+catentryId).val('yes');
						  }
					  }else if(avlTxt == 'RED'){
						  $('[id="'+availabilityEle+'"]').addClass("hide");
						  $('[id="'+availabilityEle+'"]').removeClass("show");
						  $('[id="'+nonAvailabilityEle+'"]').addClass("show");
						  $('[id="'+nonAvailabilityEle+'"]').removeClass("hide");
						  $('[id="'+lowAvailabilityEle+'"]').addClass("hide");
						  $('[id="'+lowAvailabilityEle+'"]').removeClass("show");
						  if(bopusSelectIdLength > 0){
							  disableButton = true;
						  }
					  }else{
						  $('[id="'+availabilityEle+'"]').addClass("hide");
						  $('[id="'+availabilityEle+'"]').removeClass("show");
						  $('[id="'+nonAvailabilityEle+'"]').addClass("hide");
						  $('[id="'+nonAvailabilityEle+'"]').removeClass("show");
						  $('[id="'+lowAvailabilityEle+'"]').addClass("show");
						  $('[id="'+lowAvailabilityEle+'"]').removeClass("hide");
						  if(bopusSelectIdLength > 0){
							  disableButton = true;
						  }
					  }

					  				  }
				  $("div#payment-buttons a.btn-paypal.disabled").removeClass("disabled");
				  if(disableButton){					  
					  petcoCommonJS.isDisableCheckOutButtonForBopus = true;
					  $("div#payment-buttons a.btn-paypal:not(.disabled)").addClass("disabled");
				  }else if (enableButton &&  !petcoCommonJS.isDisableCheckOutButtonForBopus){
					  petcoCommonJS.isEnableCheckOutButtonForBopus =true ;


					  					  				  }

				  			  },
			  changeStlocIdForCheckout:function(stlocId){
				  var iscart = $('article.cart-product-item');
					if(iscart.length > 0){
							 var BOPUSFFMCENTER = $("#BOPUS_FFMCENTER");
							 if(BOPUSFFMCENTER.length > 0){
								 var url = '',
							 		protocol = window.location.protocol,
							 		hostname = window.location.hostname,
									portname = window.location.port,
							 		rootPath = '/wcs/resources/store/'+petcoCommonJS.storeId+'/petcostorelocator/';
									if( portname != "" ){
										hostname = hostname+":"+portname;
									}
									if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
										rootPath = '/wcs/previewresources/store/'+petcoCommonJS.storeId+'/petcostorelocator/';
									}
								 url = protocol + '//' + hostname + rootPath + 'getstlocaddrdtls?stlocId='+stlocId;
								 	$.ajax({
								 		url : url,
								 		type : 'GET',
								 		contentType:'application/json',
								 		dataType: 'json',
								 		success: function(data){
								 		BOPUSFFMCENTER.val(data.bopusAddressDetails.FFMCENTER);
									petcoCommonJS.updateBopusStoreinCart();

								 										},								
								error: function(error){
									console.log(storeNLS["INV_STATUS_RETRIEVAL_ERROR"]);
								}
							});
						}
					}else if( $('input[type="radio"][id^="store-pickup_"]').length > 0){
					  if( $('input[type="radio"][id^="store-pickup_"]:checked').length > 0){
							 var BOPUSFFMCENTER = $("#BOPUS_FFMCENTER");
							 if(BOPUSFFMCENTER.length > 0){
								 var url = '',
							 		protocol = window.location.protocol,
							 		hostname = window.location.hostname,
									portname = window.location.port,
							 		rootPath = '/wcs/resources/store/'+petcoCommonJS.storeId+'/petcostorelocator/';
									if( portname != "" ){
										hostname = hostname+":"+portname;
									}
									if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
										rootPath = '/wcs/previewresources/store/'+petcoCommonJS.storeId+'/petcostorelocator/';
									}


																										 url = protocol + '//' + hostname + rootPath + 'getstlocaddrdtls?stlocId='+stlocId;
								 	$.ajax({
								 		url : url,
								 		type : 'GET',
								 		contentType:'application/json',
								 		dataType: 'json',
								 		success: function(data){
								 		BOPUSFFMCENTER.val(data.bopusAddressDetails.FFMCENTER);

								 										 		$('input[type="radio"][id^="store-pickup_"]:checked').trigger('click');
								 		},
								 		error: function(error){
								 			console.log(storeNLS["INV_STATUS_RETRIEVAL_ERROR"]);
								 		}

								 	});


								 								 							 }

							 					  }else if( $('input[type="radio"][id^="one-time-delivery_"]:checked').length > 0){
						  setTimeout("cursor_wait()",500);
						  $('input[type="radio"][id^="one-time-delivery_"]:checked').trigger('click');
					  }else if( $('input[type="radio"][id^="repeat-delivery-radio_"]:checked').length > 0){
						  setTimeout("cursor_wait()",500);
						  $('input[type="radio"][id^="repeat-delivery-radio_"]:checked').trigger('click');
					  }else if( $('input[type="radio"][id^="sameday-delivery_"]:checked').length > 0){
						  setTimeout("cursor_wait()",500);
						  $('input[type="radio"][id^="sameday-delivery_"]:checked').trigger('click');
					  }
				  }
			  },
			 updateBopusStoreinCart: function(){
				 var orderitem = "";
				 var shipmodeId = "";
				 var fullfillmentId = "";
				 var fromBopus = "";
				 $("div#cart_bopus_items").each(function() {
					var name = $(this).find("div").attr('name'); 
					if(name != undefined){
						if(name.startsWith("store-pickup")){
							var input = $(this).find("div").attr('id');					
             		if(typeof(input)!= undefined){
             			var items = input.split("_");
             			orderitem = items[1];
		             			fromBopus = true;
		             		} 
				 		}
             		}
             	});  
				if(orderitem != ""){
					var params = [];
					params["storeId"] = this.storeId;
					params["catalogId"] = this.catalogId;
					params["langId"] = this.langId; 
					params["orderItemId"] = orderitem;
					var BOPUSFFMCENTER = $("#BOPUS_FFMCENTER");
					if( BOPUSFFMCENTER.size() > 0 ){
						params["fulfillmentCenterId"] = BOPUSFFMCENTER.val();
						params["storeChange"] = true;
					}
					var isEASession = dojo.cookie('isEASession');
					if (isEASession == "yes" ){
						params.calculationUsage = "-1,-2,-3,-4,-5,-7";
					}else{
						params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
					}
					cursor_wait();
					wc.service.invoke("AjaxUpdateOrderItemShopCartRDPromo",params);
				}
			 },
			  radioButtonSelectOption:function(obj,pSelectedOrderItemId,selectedProductId){
					cmManuallyTriggerEventTrack(obj);
					selectedOrderItemId=pSelectedOrderItemId;
					petcoCommonJS.repeatDeliveryCartSelected(); 
					petcoCommonJS.repeatDeliveryShopCart(selectedProductId, true);
				},
			  changeDeliveryType:function(obj,pSelectedOrderItemId,deliveryType){
						cmManuallyTriggerEventTrack(obj);
						selectedOrderItemId=pSelectedOrderItemId;
						var params = [];
						params["storeId"] = this.storeId;
						params["catalogId"] = this.catalogId;
						params["langId"] = this.langId;
						 params["priceChange"] = true;
						 params["orderItemId"] = selectedOrderItemId;
						 params["callToODM"] = "true";
						 var isSpecialItem =  $("#isSpecialItem_"+selectedOrderItemId).val();
						 if(isSpecialItem == 'false'){
							 params["mergeOrderItems"] = "true";
						 }
						 if($("#ignoreNewRowCreation_"+selectedOrderItemId).size() != 0){
							 params["isPersonalizationRow"] = $("#ignoreNewRowCreation_"+selectedOrderItemId).val();
						 }
						 if(deliveryType == 'store-pickup'){
							 var BOPUSSHIPMODE = $("#BOPUS_SHIPMODE");
							 var BOPUSFFMCENTER = $("#BOPUS_FFMCENTER");
								if(BOPUSSHIPMODE.size() > 0 && BOPUSFFMCENTER.size() > 0 ){
									params["shipModeId"]		= BOPUSSHIPMODE.val();
									params["fulfillmentCenterId"] = BOPUSFFMCENTER.val();
									params["fromBopusPage"] = true;
								}
						 }else if(deliveryType == 'one-time'){
								var DEFAULTFFMCENTER = $("#DEFAULT_FFMCENTER");
								var DEFAULTSHIPMODE = $("#DEFAULT_SHIPMODE");	
								var storeID = $('#bopusPhysicalStoreSelected').val();
								if(DEFAULTFFMCENTER.size() > 0 && DEFAULTSHIPMODE.size() > 0 ){
									params["shipModeId"]		= DEFAULTSHIPMODE.val();
									params["fulfillmentCenterId"] = DEFAULTFFMCENTER.val();
									params["fromBopusPage"] = false;
								}else if(typeof(storeID) == "undefined"){
									params["shipModeId"]		= "10650";
									params["fulfillmentCenterId"] = "10051";
									params["fromBopusPage"] = false;
								} 
						 }else if(deliveryType == 'sameday'){
								var sddffmcenter = $("#SDD_fulfillmentcer_"+selectedOrderItemId).val();
								console.log("sddffmcenter -> "+sddffmcenter);
								var SAMEDAYSHIPMODE = $("#SAMEDAY_SHIPMODE_ID");
								if(SAMEDAYSHIPMODE.size() > 0 ){
									params["shipModeId"]		= SAMEDAYSHIPMODE.val();
									params["fulfillmentCenterId"] = sddffmcenter;
									params["fromBopusPage"] = false;
									params["SameDayOpted"] = true;
								} 
						 }
						var isEASession = dojo.cookie('isEASession');
						 if (isEASession == "yes" ){
								params.calculationUsage = "-1,-2,-3,-4,-5,-7";
						  }else{
								params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
							}
						 cursor_wait();
						 wc.service.invoke("AjaxUpdateOrderItemShopCartRDPromo",params);
				},

								showModalNotificationAlert: function(message, messageType){
                      $('#modal-notification-alert-message').html(message);
                      if(messageType == 'success'){
                    	  $('#modal-notification-alert .alert').addClass('success-box');
                      }else {
                    	  $('#modal-notification-alert .alert').addClass('error-box');
                      }
                      petcoCommonJS.showModal('modal-notification-alert');
                },
                updateItemButton: function(qtyChanged){
                	if($("#existingCatentryId") != null && $("#existingCatentryId") != undefined){
	                	if(qtyChanged && $("#existingCatentryId").size() > 0 && $("#existingQty").size() > 0){			
	            			if($("#existingQty").val() == $('#quantity').val() && $("#existingCatentryId").val() == $("#selectedCatentryId").val()){
	            				qtyChanged = false;
	            			}
	            		}
                	}
                	if(document.getElementById("allowedChange") != null && document.getElementById("allowedChange") != undefined){
	            		var allowedChange = document.getElementById("allowedChange").value;		
	            		if(qtyChanged || allowedChange == "true")
	            			$('#updateItemBtn').removeAttr('disabled');
	            		else {	
	            			if (parseInt($('#quantity').val()) == 1 && $("#existingQty").val() != $('#quantity').val()) {				
	            				$('#updateItemBtn').removeAttr('disabled');
	            			}else {
	            				$('#updateItemBtn').attr('disabled','disabled');
	            			}			
	            		}
                	}
                },
                csrRunAsSession:function(url){
            		window.localStorage.removeItem('NEXT_REPEAT_DELIVERY_DATE');
            		window.localStorage.removeItem('PALS_POINTS');

            		            		if($("#isMembershipV2Enabled").val() != undefined && $("#isMembershipV2Enabled").val() != '' && $("#isMembershipV2Enabled").val() == 'true' && url.includes("CSREndRunAsSession") && getCookie('membership_pilot') != null && getCookie('membership_pilot') != ''){
            			dojo.cookie("membership_pilot", null, {expires: -1, path:'/'});
            		}
            		document.location.href = encodeURI(url);
            	},
            	 dataFilter: function (data) {
	                    return data.replace(/(\/\*|\*\/)/g, '');
	                },
            	getAdobeTargetContent:function(targetTest,storeConfName,defaultVal){
            		var adobeTargetCmdUrl =  "PetcoAdobeABTesting?storeId="+WCParamJS.storeId+"&catalogId="+WCParamJS.catalogId+"&langId="+WCParamJS.langId;            			
            			var params={};
						params.targetTest=targetTest;
						var isOBOSession = dojo.cookie('isOBOSession');
						var isEASession = dojo.cookie('isNewEASession');
						if(isOBOSession != "yes" && isEASession != "yes" ){
	            			$.ajax({
	                            url: adobeTargetCmdUrl,
	                            type: 'POST',
	                            cache: false,
	                            data: params,
	                            success: function(data) {
	                            	console.log("Success adobe target="+targetTest);
	                            	var filterData = petcoCommonJS.dataFilter(data);
	                            	var resJson = jQuery.parseJSON(filterData); 
	                        		if(resJson.adobeTargetResult != null){   
	                        			var option = resJson.adobeTargetResult.option;
	                        			if(typeof(option) == undefined || option == "")
	                        				option=defaultVal;
	                					sessionStorage.setItem(storeConfName, option);
	                            		Visitor.getInstance(resJson.adobeTargetResult.organizationId, {serverState: resJson.adobeTargetResult.visitorState});
	                				}else{
	                					sessionStorage.setItem(storeConfName, defaultVal);
	                				}

	                    				 	                            },
	                            error: function() {
	                            	 console.log("error while connecting to adobe target="+targetTest);
	                            	 sessionStorage.setItem(storeConfName, defaultVal);
	                            }

	                            	            			});
						}else{
							sessionStorage.setItem(storeConfName, defaultVal);
						}
            	},setATVisitorInstance:function(){
            		var organizationId = dojo.cookie('AT_organizationId');
            		var visitorState = dojo.cookie('AT_visitorState');
            		if( organizationId != undefined && visitorState != undefined )
						Visitor.getInstance(dojo.cookie('AT_organizationId'), {serverState: dojo.cookie('AT_visitorState')});
	},
	getNearestStoreInfoForHeader: function(expirationMin,isGoogleGeoAPI,HTML5GeoTimeout,XHRTimeout,googleAPIUrl,googleAPIKey) {
		petcoCommonJS.locationConfig.expirationMin = expirationMin;
		petcoCommonJS.locationConfig.isGoogleGeoAPI = isGoogleGeoAPI;
		petcoCommonJS.locationConfig.HTML5GeoTimeout = HTML5GeoTimeout;
		petcoCommonJS.locationConfig.XHRTimeout = XHRTimeout;
		petcoCommonJS.locationConfig.googleAPIUrl = googleAPIUrl;
		petcoCommonJS.locationConfig.googleAPIKey =googleAPIKey;
		petcoCommonJS.userLocation.latitude = dojo.cookie("Edgescape-Lat");
		petcoCommonJS.userLocation.longitude = dojo.cookie("Edgescape-Long");
		if (localStorage.getItem('petcostores_latitude_longitude') == null) {
			petcoCommonJS.fnGetUserLocation();
		}
		var userType = dojo.cookie("WC_UserType"),
			userId = dojo.cookie("WC_UserId"),
			prefStoreData = null;
		var localStorageKey = "pref_store_" + userId;
		var nearestStoreKey = "nearestStore_" + userId;
		if (userType == 'R') {
			var prefStoreData = localStorage.getItem(localStorageKey) != null ? jQuery.parseJSON(localStorage.getItem(localStorageKey)) : null;
			if (null == prefStoreData) {
				petcoCommonJS.getPreferredStore(userId);
			}
		}
		setTimeout(function () {
			var userLocation = jQuery.parseJSON(localStorage.getItem('petcostores_latitude_longitude'));
			if (null != userLocation && userLocation.hasOwnProperty("latitude") && userLocation.hasOwnProperty("longitude")) {
				petcoCommonJS.userLocation.latitude = userLocation.latitude;
				petcoCommonJS.userLocation.longitude = userLocation.longitude;
            	}			  
			if (sessionStorage.getItem(nearestStoreKey) == null || !(userLocation.hasOwnProperty("latitude") && userLocation.hasOwnProperty("longitude"))) {
				var url = '',
					path = '/wcs/resources/store/' + $("#storeId").val() + '/petcostorelocator/getAllStoresLatLong',
					hostname = window.location.hostname,
			 		portname = window.location.port;
					if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
						path = '/wcs/previewresources/store/'+$("#storeId").val()+'/petcostorelocator/getAllStoresLatLong';
					}
					if( portname != "" ){
				 		hostname = hostname+":"+portname;
				 	}
				url = window.location.protocol + '//' + hostname + path;
				$.get(url, 'json')
					.done(function (data) {
						petcoCommonJS.getNearestStoreForHeader(data, petcoCommonJS.userLocation);
						setTimeout(function () { petcoLocation.populateCity(); }, 500);
					});
}
		}, 10000);
	},
	getNearestStoreForHeader: function (_all_stores, _userLocation) {
		var store = _all_stores.store,
			minDistance = null,
			nearestStore = null,
			userType = dojo.cookie("WC_UserType"),
			userId = dojo.cookie("WC_UserId"),
			prefStoreData = null;
		var localStorageKey = "pref_store_" + userId;
		var nearestStoreKey = "nearestStore_" + userId;
		var prefStoreData = localStorage.getItem(localStorageKey) != null ? jQuery.parseJSON(localStorage.getItem(localStorageKey)) : null;
		$.each(store, function (key, storeLocationInfo) {
			if (userType === 'R' && null != prefStoreData) {
				if (prefStoreData.prefStore == storeLocationInfo.ID) {
					nearestStore = storeLocationInfo.SN;
					return true;
				}
			} else {
				var dist = petcoCommonJS.distance(storeLocationInfo, petcoCommonJS.userLocation);
				storeLocationInfo.distance = dist;
				if (!minDistance) {
					minDistance = dist;
					nearestStore = storeLocationInfo.SN;
				} else if (parseFloat(dist) < parseFloat(minDistance)) {
					minDistance = dist;
					nearestStore = storeLocationInfo.SN;
				}
			}
		}
		);
		if (window.sessionStorage) {
			sessionStorage.setItem(nearestStoreKey, nearestStore);
		}
		return nearestStore;
	},

	distance: function (storeLocation, userLocation) {
		return parseFloat(Math.sqrt((Math.pow(69.1 * (storeLocation.LA - userLocation.latitude), 2) + Math.pow(69.1 * ((userLocation.longitude - storeLocation.LO) * Math.cos(storeLocation.LA / 57.3)), 2)))).toFixed(2);
	},
	getPreferredStore: function (userId) {
		var url = '',
			path = '/wcs/resources/store/' + $("#storeId").val() + '/petcostorelocator/getUserPrefStore',
			hostname = window.location.hostname,
	 		portname = window.location.port;
			if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
				path = '/wcs/previewresources/store/'+$("#storeId").val()+'/petcostorelocator/getUserPrefStore';
			}
				if( portname != "" ){
			 		hostname = hostname+":"+portname;
			 	}
		url = window.location.protocol + '//' + hostname + path;
		$.get(url, 'json')
			.done(function (data) {
				if (null != data.prefStore){
					petcoCommonJS.fnPrefStoreSetLocalStorage(data.prefStore, userId);
				}				
			});
	},
	fnPrefStoreSetLocalStorage: function (prefStore, userId) {
		var localStorageKey = "pref_store_" + userId;
		localStorage.removeItem(localStorageKey);
		_timestamp = new Date().getTime();
		if (prefStore != "") {
			var prefStoreRecord = {};
			prefStoreRecord["prefStore"] = prefStore;
			var nLocationExpirationMS = 129600 * 60 * 1000;
			prefStoreRecord["timestamp"] = _timestamp + nLocationExpirationMS;
			localStorage.setItem(localStorageKey, JSON.stringify(prefStoreRecord));
		}
	},
	fnGetUserLocation: function () {
		var _nHTML5GeoTimeout = 10000;
		if (navigator && navigator.geolocation) {
			var optn = {
				enableHighAccuracy: true,
				timeout: _nHTML5GeoTimeout
			};
			navigator.geolocation.getCurrentPosition(petcoCommonJS.fnProcessGeoResponse, petcoCommonJS.fnProcessGeoError, optn);
			jQuery(window).load(function () {
				setTimeout(function () {
					if (!petcoCommonJS.IS_HTML5_CALL_COMPLETED) {
						var errorCode = {};
						errorCode.code = 5;
						petcoCommonJS.fnProcessGeoError(errorCode);
						petcoCommonJS.IS_HTML5_CALL_COMPLETED = true;
					}
				}, _nHTML5GeoTimeout);
			});

		}
	},
	fnProcessGeoResponse: function (oPosition) {
		if (petcoCommonJS.IS_HTML5_CALL_COMPLETED) {
			return;
		}
		petcoCommonJS.IS_HTML5_CALL_COMPLETED = true;
		_geoLatitude = oPosition.coords.latitude;
		_geoLongitude = oPosition.coords.longitude;
		petcoCommonJS.fnLatitudeLongitudeSetLocalStorage(_geoLatitude, _geoLongitude);

	},
	fnProcessGeoError: function (oError) {
		if (petcoCommonJS.IS_HTML5_CALL_COMPLETED) {
			return;
		}
		petcoCommonJS.IS_HTML5_CALL_COMPLETED = true;
		var errorCode = oError.code,
			errors = {
				1: 'Permission denied',
				2: 'Position unavailable',
				3: 'Request timeout',
				4: 'Unknown error',
				5: 'No input from user'
			};
		if (errorCode) {
			if (errorCode == '5') {
				petcoCommonJS.fnGetAkamaiLocation();
			} else if (errorCode != '5') {
				petcoCommonJS.fnGoogleGeoLocation();
			}
		}
	},
	fnGoogleGeoLocation: function () {
		$.ajax({
			url: petcoCommonJS.locationConfig.googleAPIUrl+petcoCommonJS.locationConfig.googleAPIKey,
			type: 'POST',
			cache: false,
			contentType: 'application/json',
			dataType: 'json',
			data: JSON.stringify({}),
			timeout: petcoCommonJS.locationConfig.XHRTimeout,
			success: function (data) {
				_geoLatitude = data.location.lat;
				_geoLongitude = data.location.lng;
				petcoCommonJS.fnLatitudeLongitudeSetLocalStorage(_geoLatitude, _geoLongitude);
			},
			error: function (error) {
				petcoCommonJS.fnGetAkamaiLocation();
			}
		});
	},
	fnGetAkamaiLocation: function () {
		petcoCommonJS.fnLatitudeLongitudeSetLocalStorage(petcoCommonJS.userLocation.latitude, petcoCommonJS.userLocation.longitude);
	},
	fnLatitudeLongitudeSetLocalStorage: function (lat, long) {
		localStorage.removeItem("petcostores_latitude_longitude");
		if (lat != "" && long != "") {
			var oLatLongRecord = {};
			oLatLongRecord["latitude"] = lat;
			oLatLongRecord["longitude"] = long;
			var nLocationExpirationMS = 129600 * 60 * 1000;
			_timestamp = new Date().getTime();
			oLatLongRecord["timestamp"] = _timestamp + nLocationExpirationMS;
			localStorage.setItem("petcostores_latitude_longitude", JSON.stringify(oLatLongRecord));
		}
	},
	fnOpenPromotionDesc:function(promotionId){

				var url = '',
		path = '/wcs/resources/store/' + $("#storeId").val() + '/promotion/description/'+promotionId,
		hostname = window.location.hostname,
 		portname = window.location.port;
		if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
			path = '/wcs/previewresources/store/'+$("#storeId").val()+'/promotion/description/'+promotionId;
		}
		if( portname != "" ){
	 		hostname = hostname+":"+portname;
	 	}
	url = window.location.protocol + '//' + hostname + path;


		$.get(url, 'json')
		.done(function (data) {
			 var promoDesc = "Promotion details not available";
			 if(data != null && data.longDescription != "")
				 promoDesc = data.longDescription;		
			 $('#petco-promo-desc-modal').html(promoDesc);
			 petcoCommonJS.showModal('promoDesc');
		}).fail(function() {
			$('#petco-promo-desc-modal').html("Promotion details not available");
			 petcoCommonJS.showModal('promoDesc');
		  });

	},assign_catentry_value:function(itemsId){
		if(document.getElementById("catEntryIdForBOPUSModal") != null){
			document.getElementById("catEntryIdForBOPUSModal").value= itemsId;
		}
	},calculatedRDPrice:function(){	
		if($("#isCalculatedRDEnabled").length > 0 && 'true' == $("#isCalculatedRDEnabled").val()){
			var jsonObj = [];
			var calculatedRDPriceMap={};
			$(".rdEligibleItem").each(function(ind,obj){
				  var lineValArr = obj.value.split("|");
				  var item={};
				  item.partNumber=lineValArr[0];
				  item.offerPrice=lineValArr[1];
				  item.rdPrice=lineValArr[2];
				  var orderItemId=lineValArr[3];
				  var isFreshPet = lineValArr[4];
				  if(!isFreshPet == null || isFreshPet != "true"){
					  jsonObj.push(item);
				  }				  				 
			});	
			if(jsonObj.length > 0){
				var reqObj = {};
				reqObj.rdPriceDetail = jsonObj; 
				var protocol = window.location.protocol;
		 		var hostname = window.location.hostname;
				var portname = window.location.port;
				var rootPath = '/wcs/resources/store/10151/productinfo/calculatedRDPrice/';

								if( portname != "" ){
					hostname = hostname+":"+portname;
				}	
				var url = protocol+"//"+hostname+rootPath;
				$.ajax({
			 		url : url,
			 		type : 'POST',
			 		cache : false,
			 		contentType: 'application/json',
			 		dataType: 'json',
			 		data: JSON.stringify(reqObj),
			 		success: function(data){
			 			if(null != data){
			 				var rdData=data["rdPriceDetail"];
			 				if(typeof(rdData) != 'undefined'){
			 					for (var x in rdData ){ 
			 						var rdPrice = (rdData[x].rddiscountprice).toFixed(2);			 						
			 						calculatedRDPriceMap[rdData[x].partNumber] = rdPrice;
			 						$("div[id="+rdData[x].partNumber+"_rdcalculated]").html("<p style=\"text-align:right\"> or </p> <span class=\"cart-price cart-price-small rdLogo\">$"+rdPrice+"</span><p> With Repeat Delivery.</p><p>Select in Checkout</p>");
			 					}	 
			 				}
			 			}
			 		},
			 		error: function(){
			 			console.log("CalculatedRDPrice---> error....");
			 		}
			 	}); 
			}
		}
	},
	displayContentNavResult: function(path,facetName){
		var contentParam = '&catalogId='+this.catalogId+'&langId='+this.langId+'&storeId='+this.storeId+'&contentPath='+path+'&path='+path+'&facetName='+facetName;
	    $.ajax({
			url: getAbsoluteURL() + 'AjaxContentNavResultView',
		    type: 'POST',
		    data: contentParam,
		    success: function(responseText){
		        $('#contentNavResult').html(responseText);
		    },
		    error: function(responseText){
		    }
		});
	},
	displayContentSearchResult: function(path,facetName,totalContentCount,index){
	    var searchParam = '&catalogId='+this.catalogId+'&langId='+this.langId+'&storeId='+this.storeId+'&totalContentCount='+totalContentCount+'&type=categorySearch'+'&categoryNames='+path+'&facetName='+facetName+'&index='+index;
		$.ajax({
			url: getAbsoluteURL() + 'AjaxContentResultsListView',
		    type: 'POST',
		    data: searchParam,
		    success: function(responseText){
		        $('#contentSearch').html(responseText);
		    },
		    error: function(responseText){
		    }
		});
	},
	displayZipcodeForSameday : function(){
		var zipcode = productDisplayJS.getZipCodeForSameday();
		if(zipcode==null){
			if($("#SDdefaultZip").length > 0){
				zipCode = $("#SDdefaultZip").val();
			}
		}
		$('span[id="sameday-zipcode"]').html(zipcode);
	}	

}

dojo.topic.subscribe("ajax_usertype_changed", function(usertypes){
	var oNeareststores = JSON.parse(localStorage.getItem('petcostores'));
	if(oNeareststores != null && typeof(oNeareststores.userDetails) != 'undefined' ){
		var userdetails = JSON.parse(oNeareststores.userDetails);
		if(typeof(userdetails.USERTYPE) != 'undefined' && typeof(userdetails.SHOW_PREFERREDSTORE) != 'undefined' && userdetails.SHOW_PREFERREDSTORE.toUpperCase() == 'Y'  ){
			var USERTYPE = userdetails.USERTYPE;
			if(usertypes != USERTYPE){
				localStorage.removeItem('petcostores');
				var hostName = document.location.host;
				var domainName = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1));
				var date = new Date();
				date.setTime(date.getTime()+(-100*24*60*60*1000));
				expires = '; expires='+date.toGMTString();
				document.cookie = 'WC_physicalStores='+expires+';path=/';

								var petcoNearestLocationsInitScript =  document.getElementById("petcoNearestLocationsInitScript");
				if( petcoNearestLocationsInitScript != null){
					eval(petcoNearestLocationsInitScript.innerHTML);
					 dojo.topic.subscribe('ChangeBasedOnLocationCallCompleted', function(){
						 var elPDPContainer = $('div[data-pageType="product-detail-page"]');
						 var elPLPConatiner = $('div#bopusInfoTabInPlp_conatiner');
						 	if(elPLPConatiner.length > 0 ){
							 	dojo.topic.publish("Facet_Update","");
						 	}
							if(elPDPContainer.length > 0 ){
								dojo.topic.publish('DefiningAttributes_Resolved', productDisplayJS.bopusShowStoreDetailsCatEntryId,productDisplayJS.bopusShowStoreDetailsProductId );
							}

						 					 });

									}

							}
		}
	}	
});

function isCloudniaryEnabled(){
	var isCloudniaryEnabledFlag = $("#ENABLE_CLOUDNIARY");
	if( isCloudniaryEnabledFlag &&  isCloudniaryEnabledFlag.val() == 'true'){
		return true;
	}
	return false;
}
function redirect(redirectView){
	location.href= redirectView;
}

function showConfirmContainer(subscriptionId, orderId){
	if(!submitRequest()){
		 return;
	} 
    var selectedMainReason = $('input[name=repeatDeliveryCancellationReason]:checked').val();
    var selectedMainReasonId = $('input[name=repeatDeliveryCancellationReason]:checked').attr('id');
    var selectedSubReason = $('input[name=repeatDeliveryCancellationSubReason]:checked').val();
    var selectedSubReasonId = $('input[name=repeatDeliveryCancellationSubReason]:checked').attr('id');
    var othersReasonDetail = $('#othersReasonDetail').val();
    var rdOrderStatus = $('#rdOrderStatus').val();
    var hasError = $('#hasError').val();
    var isAllowedToChange = $('#isAllowedToChange').val();
    var isEditable = $('#isEditable').val();
    var nowScheduledDate = $('#nowScheduledDate').val();
    var nextDate = $('#nextDate').val();
    var rxFoodIndicatorFlag = $('#rxFoodIndicatorFlag').val();
    var isFreshPetRd = $('#isFreshPetRd').val();

        wc.render.updateContext("PetcoCancelRepeatDeliveryConfirmation_Context",{"subscriptionId":subscriptionId, "orderId":orderId, "selectedMainReason":selectedMainReason, 
    	"selectedMainReasonId":selectedMainReasonId, "selectedSubReason":selectedSubReason, "selectedSubReasonId":selectedSubReasonId, "rdOrderStatus":rdOrderStatus, 
    	"hasError":hasError, "isAllowedToChange":isAllowedToChange, "isEditable":isEditable, "nowScheduledDate":nowScheduledDate, "nextDate":nextDate, "rxFoodIndicatorFlag":rxFoodIndicatorFlag, "isFreshPetRd":isFreshPetRd},"");

        $(".rd-cancellation-container").hide();
    $(".rd-cancellation-hero").hide();
    $(".rd-cancellation-confirm-top-hero").show();

    }

function htmlDecode(input) {
	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

function updateSFText() {
    $('.uiOutputRichText').text(function(_, oldText){
                return htmlDecode(oldText);
        });
}

$(document).ready(function(){
	$('.icon-tooltip').focusin(function(){
		var tooltipId = $(this).attr('id');
		  $('#'+tooltipId).popover('show');
	});
	$('.icon-tooltip').focusout(function(){
		var tooltipId = $(this).attr('id');
		  $('#'+tooltipId).popover('hide');
	});

		if ($('.sdd-ship-tooltip')) {
		var popOverSettings = {
			    placement: 'top',
			    trigger: 'hover',
			    html: true,
			    selector: '.sdd-ship-tooltip',
			    content: function () {
			        return $('#sdd-shipping-tooltip-content').html();
			    }
		}
		$('body').popover(popOverSettings);
	}

	    $(".single-reason").click(function(){

                $(".reason-button-container").hide();
        $('.sub-reason-container input:radio:checked').each(function() {
            $(this).prop('checked', false);
        });
        if($(this).parent().hasClass("no-sub-reason")){

            var id = $(this).attr('id');
            $(".sub-reason-container").hide();
            $("#subreasons_"+ id).show();

            $("#repeatDeliveryCancellationBtn").removeAttr('disabled');
            $("#cancelRDModalBtn").removeAttr('disabled');
            $(".rd-cancellation-button-container").hide();
            $(".reason-button-container").html('');
            if($(this).parent().hasClass("other-reason")){
                $(this).next().next(".reason-button-container").html($(".rd-cancellation-button-container").html());
                $(this).next().next(".reason-button-container").show();
            }else{
                $(this).next(".reason-button-container").html($(".rd-cancellation-button-container").html());
                $(this).next(".reason-button-container").show();
            }

        }else{

            $("#repeatDeliveryCancellationBtn").attr('disabled', 'disabled');
            $("#cancelRDModalBtn").attr('disabled', 'disabled');
            $(".rd-cancellation-button-container").show();
            var id = $(this).attr('id');
            $(".sub-reason-container").hide();
            $("#subreasons_"+ id).show();
            $(".reason-button-container").html('');

        }

    });

    $(".single-sub-reason").click(function(){

        $(".reason-button-container").hide();
        $("#repeatDeliveryCancellationBtn").removeAttr('disabled');
        $(".rd-cancellation-button-container").hide();
        $(".reason-button-container").html('');
        $(this).next(".reason-button-container").html($(".rd-cancellation-button-container").html());
        $(this).next(".reason-button-container").show();

    });	
    $('.product_quantity_input').keyup(function(){
    	if($(this).val() != '' && $(this).val() < 0){
    		$(this).val('1');
    	}
    });
    $(document).on("keyup",".product_quantity_input",function($event){
    	if($(this).val() != '' && $(this).val() < 0){
    		$(this).val('1');
    	}
    });

        $('.product_quantity_input').blur(function(){
    	if($(this).val() == '' || $(this).val() < 0){
    		$(this).val('1');
    		$(this).trigger('change');
    		localStorage.setItem('qtyChangedOnBlur', '1');
    		if($(this).attr('id') == 'quantity'){    			
    			petcoCommonJS.updateItemButton(true);
    		}
    	}
    });
    $(document).on("blur",".product_quantity_input",function($event){
    	if($(this).val() == '' || $(this).val() < 0){
    		$(this).val('1');
    		$(this).trigger('change');
    		localStorage.setItem('qtyChangedOnBlur', '1');
    		if($(this).attr('id') == 'quantity'){    			
    			petcoCommonJS.updateItemButton(true);
    		}
    	}
    });
    $('input[maxlength]').on('textInput', function (event) {
        var $this = $(this);
        if ($this.val().length >= parseInt($this.attr('maxlength'), 10)) {
            event.preventDefault();
        }
    });

 	    var widthOfWindows = $(window).width()*0.5;    
 	    var heightOfWIndows = $(window).height()*0.7;
 		var isMobile = window.matchMedia("(max-width: 768px)").matches;
 		if(!isMobile){
 		    $("#look-ahead").width(widthOfWindows);
 		    $("#look-ahead").height(heightOfWIndows);
 		}
});

$(document).on('keydown', '.uiInputTextArea', function(event) {
	console.log('test live chat');
	var keycode = (event.keyCode ? event.keyCode : event.which);	
	if(keycode == '13'){
	   setTimeout( updateSFText, 500);
	}
});

$(document).keyup(function(event) {
    if($('.petco-modal').hasClass('in')) {
		var hideModalId = $('.petco-modal.in')[0].getAttribute('id');
	   if (event.keyCode == 27 && hideModalId) { 
		  petcoCommonJS.hideModal(hideModalId);
	   }
   }
});
$(document).mouseup(function (e) {
    if ($('.petco-modal').hasClass('in')) {
		var hideModalId = $('.petco-modal.in')[0].getAttribute('id');
		var container = $("#" + hideModalId);
		if (hideModalId) {
			if (!container.is(e.target) && container.has(e.target).length === 0) {				
				petcoCommonJS.hideModal(hideModalId);
			}
		}
		if (hideModalId == 'modal-cartListItems') {
			trackATCInterstitailClick('modal_click_away');
		}
	}
});

function oneTrust(){
	const jwt_token_payloadSession = sessionStorage.getItem('jwt_token_payload');
	  const onetrust_token = sessionStorage.getItem('onetrust_token');

	  const jwtTokenPayloadParsed = JSON.parse(jwt_token_payloadSession);

	  const jwtTokenPayload1 = { sub: jwtTokenPayloadParsed.sub, isAnonymous: jwtTokenPayloadParsed.isAnonymous };
	  const dataSubjectParams = { dataSubjectParams: {  id: jwtTokenPayload1.sub, isAnonymous: jwtTokenPayload1.isAnonymous, token: onetrust_token }};


	  	  		const otFormStubSrc = $("#oneTrustWEBformScript").val();

		const oneTrustWebFormDataId = $("#oneTrustWEBformDataId").val();
		const oneTrustDataDomainScript = $("#oneTrustDomain").val();
		const scriptSrc = $("#oneTrustScript").val();
		const OptanonWrapperInlineScript = "function OptanonWrapper(){OneTrust.InsertScript('https://petco19671z.btttag.com/btt.js','head',null,null,'CADNS');OneTrust.webform.InstallCP('bedd0992-196a-4920-8686-07360f950b05');}";

				const dataScript = document.createElement('script');
		dataScript.type = 'text/javascript';
		dataScript.text =
		  'var jwtTokenPayload = ' + JSON.stringify(jwtTokenPayload1) + ';' +
		  'var OneTrust = {' +
		    'dataSubjectParams: ' + JSON.stringify(dataSubjectParams) +
		  '};';
		document.head.appendChild(dataScript);

		const otFormStubScript = document.createElement('script');
		otFormStubScript.type = 'text/javascript';
		otFormStubScript.src = otFormStubSrc;
		otFormStubScript.defer = true;
		otFormStubScript.setAttribute('data-id', oneTrustWebFormDataId);
		document.head.appendChild(otFormStubScript);

		const otSDKScript = document.createElement('script');
		otSDKScript.type = 'text/javascript';
		otSDKScript.src = scriptSrc;
		otSDKScript.defer = true;
		otSDKScript.setAttribute('data-domain-script', oneTrustDataDomainScript);
		document.head.appendChild(otSDKScript);

		const optanonWrapperScript = document.createElement('script');
		optanonWrapperScript.defer = true;
		optanonWrapperScript.text = OptanonWrapperInlineScript;
		document.head.appendChild(optanonWrapperScript);

}
function trackATCInterstitailClick(action) {	
	var events = window.PetcoDataLayer["events"] || {};	
	if(action == 'modal_opened') {
		events["evar95"] = action;
		events["event115"] = "1";
		window.PetcoDataLayer["events"] = events;
	} else {		 
		var list2val = events["evar95"];
		var eventDetails = {};	
		eventDetails["event_name"] = action;
		if(list2val != '' && list2val != 'modal_opened'){			
			list2val = list2val + "|" + action;
			var tokens = list2val.split("|");
			eventDetails["event115"] = ""+tokens.length;
			eventDetails["evar95"] = list2val;					
		} else {
			list2val =  action;
			eventDetails["event115"] = "1";
			eventDetails["evar95"] = list2val;
		}	
		pushEvent(eventDetails);
	}
}
